import clsx from 'clsx';
import { BsCalendar3 } from 'react-icons/bs';
import { HiOutlinePlusCircle } from 'react-icons/hi';
import { HiOutlineQueueList } from 'react-icons/hi2';
import styled from 'styled-components';

import { HRPlain } from 'components/Groups/Group.style';
import NavLinkLabel from 'components/Navbar/NavLinkLabel';
import { Button } from 'components/shared/Button/Button';
import { device } from 'config/device';
import { useNavigation } from 'hooks/useNavigation';

import { Loading } from '../../components/shared/Loading';

const FlexContainer = styled.ul`
  padding: 2.5rem 0;
  overflow: hidden;
  list-style: none;
  display: grid;
  grid-gap: 2.5rem;
  grid-template-columns: repeat(auto-fill, minmax(30rem, 1fr));
  @media ${device.tablet} {
    grid-column-gap: 1.5rem;
    grid-row-gap: 0.5rem;
    h3 {
      font-size: ${(props) => props.theme.medium};
    }
    button {
      font-size: ${(props) => props.theme.small};
    }
    svg {
      height: 2rem;
      width: 2rem;
    }
  }
  @media ${device.mobile} {
    margin: 0;
    grid-gap: 2.5rem;
  }
  .homeCard {
    background: #ffffff;
    padding: 20px;
    box-shadow: ${(props) => props.theme.shadow[3]};
    // box-shadow: #8e8888 0px 2px 4px -1px;
    border-radius: 8px;
  }
  .menu {
    gap: 1.5rem;
    padding-top: 1rem;
    display: flex;
    flex-wrap: wrap;

    @media ${device.tablet} {
      padding: 0;
    }
  }
  button {
    cursor: pointer;
    flex: 1;
    width: max-content;
    padding: 0.7rem 1rem;
    border-radius: 10px;
    gap: 1rem;
    display: flex;
    flex-direction: row;
    svg {
      height: 2rem;
      width: 2rem;
    }
    &.newBtn {
      background: none;
      color: ${(props) => props.theme.special};
      border: solid 2px;
    }
  }
`;

type HomeMenuProps = {
  objects: any[];
};

export function HomeMenu({ objects }: HomeMenuProps) {
  const filterdObjects = objects.filter((item) => {
    if (!item.MENUOPTIONS) return false;
    return item.MENUOPTIONS.some((m: any) => m.DISPLAYONDASHBOARD);
  });
  if (!objects.length) return <Loading />;
  return (
    <FlexContainer>
      {filterdObjects.map((item: any) => {
        return (
          <li className='homeCard' key={item.OBJECTID}>
            <h3>{item.OBJECTNAME}</h3>
            <HRPlain />
            <div className='menu'>
              {item.MENUOPTIONS.map((option: any, index: number) => {
                if (!option.DISPLAYONDASHBOARD) return null;
                return <ButtonLink key={index} object={item} option={option} />;
              })}
            </div>
          </li>
        );
      })}
    </FlexContainer>
  );
}

type ButtonLinkProps = {
  object: any;
  option: any;
};

function ButtonLink({ object, option }: ButtonLinkProps) {
  const navigate = useNavigation(object.OBJECTPATH);
  return (
    <Button
      data-cy={`Button-${option.TITLE}`}
      className={clsx({ newBtn: option.TYPE === 'CREATE' })}
      onClick={() => navigate(option)}
    >
      {(() => {
        if (option.TYPE === 'CREATE') {
          return <HiOutlinePlusCircle />;
        }
        // if (option.TYPE === 'LIST') {
        //   return <HiOutlineQueueList />;
        // }
        // if (option.TYPE === 'CALENDAR') {
        //   return <BsCalendar3 />;
        // }
        return null;
      })()}
      <NavLinkLabel object={object} option={option} />
    </Button>
  );
}
